import type { ShopBankTransferRepository } from "../../repositories/shop/shop-bank-transfer-repository";
import { AppError } from "../../../shared/utils/error-handler";
import type { BankTransferEntity } from "../../types/company-bank-transfer";

export class ShopBankTransferUseCase {
  constructor(private shopBankTransferRepository: ShopBankTransferRepository) {}

  async getBankTransfers(shopId: number): Promise<BankTransferEntity[]> {
    try {
      return await this.shopBankTransferRepository.getBankTransfers(shopId);
    } catch (error) {
      throw new AppError(
        String(error) || "쇼핑몰 무통장 정보를 가져오지 못했습니다.",
        "BEST_SELLER_LIST_GET_FAILED",
        error,
      );
    }
  }
}
